import React, { useEffect, useState, useCallback } from 'react';
import { Link } from '@reach/router';
import './ManageTeam.scss';
import 'components/Dashboard/Collections/CollectionsList/CollectionsList.scss';
import PopUp from 'components/Common/PopUp/PopUp';
import { IPopUpOptions } from 'models/Dashboard/IPopUpOptions';

import ManageIcon from 'assets/icons/manage-icon.svg';
import ManageIconGray from 'assets/icons/manage-icon-gray.svg';
import classNames from 'classnames';
import map from 'lodash.map';
import { ProfileAssetCircle } from '../SidebarInfo/SidebarInfo';

export type IMembers = {
  key: string;
  name: string;
  email: string;
  accountType: string;
  activeAccount: string;
  status: string;
  inviteURL?: string;
  department: string;
};
export interface IMembersTeam {
  team?: {
    key: number;
    name: string;
    description?: string;
  };
  brand?: any;
  members: IMembers[];
  popUpOptions: IPopUpOptions[];
}

const membersSlice = 5;

const SummarizeTeam: React.FC<IMembersTeam> = props => {
  const { team, members, popUpOptions } = props;
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className='manage-team'>
      <div className='collections-list__item' key={team.key}>
        <span className='collections-list__txt'>{team?.name || team?.description}</span>
        <div className='collections-list__end'>
          <span className='collections-list__members'>
            <SummarizeProfiles members={members} />
          </span>
          {members.length > membersSlice && (
            <span className='collections-list__members-count'>
              <div className='sidebar-info__member'>
                <span>+</span>
              </div>
            </span>
          )}
          <span className='collections-list__members-count'>
            {members.length} {members.length === 1 ? `member` : `members`}
          </span>
          <img
            className='collections-list__dots'
            src={ManageIcon}
            alt='Dots'
            onClick={() => {
              setOpen(true);
              setSelectedItem(team.key);
            }}
          />
        </div>

        <PopUp open={open && selectedItem === team.key}>
          {popUpOptions &&
            popUpOptions.map(({ selectItem, onClick, to }) => (
              <li
                className='pop-up__li'
                key={selectItem}
                onClick={() => {
                  setOpen(false);
                  onClick?.();
                }}
              >
                {to ? <Link to={to}>{selectItem}</Link> : selectItem}
              </li>
            ))}
        </PopUp>
      </div>
    </div>
  );
};

const SummarizeProfiles = props => {
  const { members } = props;
  return (
    <>
      {map(
        members.slice(0, membersSlice),
        ({
          name,
          email,
          department,
          activeAccount,
          accountType,
          inviteURL,
          status,
          key,
        }) => (
          <div className='sidebar-info__member' key={key}>
            <ProfileAssetCircle firstName={name} lastName={name} />
          </div>
        )
      )}
    </>
  );
};

export default SummarizeTeam;
